import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login.vue';
import Admin from '@/views/Admin.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login', // 默认重定向到登录页面
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
    },
  ],
});
